export const environment = {
  production: false,
  apiUrl: 'https://backend-production-8a30d.up.railway.app'
};
